import { observer } from "mobx-react";
import DynamicTable from "../../../../datatable/DynamicTable";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useStore from "../../../../hooks/useStore";
import {
  ApprovalEnums,
  STATIC_GROUPS,
  USER_ROLE,
} from "../../../../constants/constants";
import DashboardHistogram from "../../../../components/dashboard-chart/dashboard-histogram";
import Performance from "../../../../components/performance";
import MobileTable from "../../../../components/mobileTable/mobileTable";
import PaginationControls from "../../../../datatable/paginationControls";
import { findKpi } from "../../../../utils/helpers";
import { Modal, Button } from "react-bootstrap";
import { useAuth } from "../../../../context/authProvider";
import LogTableBody from "../../logForms/environmentLog";
import * as XLSX from 'xlsx';
import { groupByConsecutiveGroups } from "../../../../utils/helpers";
const AqiPage = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedFormId, setSelectedFormId] = useState(null);
  const { showAlert } = useAuth();
  const navigate = useNavigate();
  const {
    userStore: { isLoggedIn, path, employeeKpis, user },
    formStore: {
      reset,
      fetchForms,
      forms,
      approveForm,
      deleteForm,
      logRaw,
      logData,
      fetchEmissionByYear,
      fetchFieldsForExcel
    },
    companyStore: {units, kpiName , companyUnit, catId, subCatId, kpiId,assignUnitsRaw, fetchAssignUnits, getCompanyUnitName},
  } = useStore();

   useEffect(() => {
      if (!assignUnitsRaw?.length) {
        fetchAssignUnits();
      }
    }, [assignUnitsRaw]);

  const handleModalOpen = (type, formId) => {
    setModalType(type);
    setSelectedFormId(formId);
    setShowModal(true);
  };
  const handleModalLogShow = async (formId) => {
    await logData({ formId });
    setModalType("log");
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedFormId(null);
    setModalType(null);
  };

  const handleConfirmAction = async () => {
    if (selectedFormId) {
      if (modalType === "approve") {
        await approveForm({
          formId: selectedFormId,
          type: "emission",
          showAlert,
          status: ApprovalEnums.Approved,
          kpiName,
          year,
        });
      } else if (modalType === "delete") {
        await deleteForm({
          formId: selectedFormId,
          type: "emission",
          showAlert,
          status: ApprovalEnums.Pending,
          kpiName,
          year,
        });
      }
      handleModalClose();
    }
  };
  const kpi = useMemo(
    () => findKpi({ kpis: employeeKpis, value: kpiName, field: "name" }),
    [employeeKpis, kpiName]
  );




// const handleDownloadEmissionExcel = async () => {
//   try {
//     const selectedYear = year;
//     const emissionData = await fetchEmissionByYear({ year: selectedYear, companyUnit, showAlert });

//     if (!emissionData || emissionData.length === 0) {
//       showAlert("No emission data available for the selected year.");
//       return;
//     }

//     const approvedForms = forms?.records?.filter(f => f.approvalStatus === "approved") || [];
//     if (approvedForms.length === 0) {
//       showAlert("No approved forms found");
//       return;
//     }
//     const approvedFormIds = approvedForms.map(f => f.formId);
//     const approvedData = emissionData.filter(item => approvedFormIds.includes(item.formId));
//     if (approvedData.length === 0) {
//       showAlert("No approved emission data available.");
//       return;
//     }

//     const fullStructure = await fetchFieldsForExcel(catId, subCatId, kpiId);
//     if (!fullStructure || fullStructure.length === 0) {
//       showAlert("Full field structure not found");
//       return;
//     }

//     const months = [
//       "January", "February", "March", "April", "May", "June",
//       "July", "August", "September", "October", "November", "December"
//     ];

//     // Group fields by groupKey
//     const grouped = {};
//     fullStructure.forEach(field => {
//       const groupKey = field?.group?.[0] || "Unknown";
//       if (!grouped[groupKey]) grouped[groupKey] = [];
//       grouped[groupKey].push(field);
//     });

//     // Helper to get UOM
//     const getUnitDisplay = (field, match) => (
//       match?.unitmaster?.shortName ||
//       match?.unitShortName ||
//       match?.unitName ||
//       match?.unit ||
//       field?.unit ||
//       units?.find(u =>
//         u.id === field?.unitId ||
//         u.id === field?.unit ||
//         u.fullName === field?.unit ||
//         u.shortName === field?.unit
//       )?.shortName ||
//       "N/A"
//     );

//     // Helper function to determine if a record belongs to the selected year
//     const isRecordFromSelectedYear = (item, expectedYear) => {
//       if (item.frequencyType?.toLowerCase() === 'daily') {
//         if (item.frequencyDate) {
//           const dateYear = new Date(item.frequencyDate).getFullYear();
//           return String(dateYear) === String(expectedYear);
//         }
//         return false;
//       } else {
//         return String(item.frequencyYear) === String(expectedYear);
//       }
//     };

//     // Helper function to get the month from a record
//     const getRecordMonth = (item) => {
//       if (item.frequencyType?.toLowerCase() === 'daily') {
//         if (item.frequencyMonth && item.frequencyMonth.trim() !== '') {
//           return item.frequencyMonth.toLowerCase();
//         }
//         if (item.frequencyDate) {
//           const dateObj = new Date(item.frequencyDate);
//           return dateObj.toLocaleString('default', { month: 'long' }).toLowerCase();
//         }
//         return null;
//       } else {
//         return item.frequencyMonth?.toLowerCase() || null;
//       }
//     };

//     // Helper function to get fields by group pattern
//     const getFieldsByGroupPattern = (pattern) => {
//       return fullStructure.filter(field => {
//         const group = field?.group;
//         if (Array.isArray(group)) {
//           return group.some(g => g.startsWith(pattern));
//         }
//         return group && group.startsWith(pattern);
//       });
//     };

//     // Helper function to calculate aggregate sum for summary fields
//     const getAggregateSum = (fieldName, month, expectedYear) => {
//       const normalizedMonth = month.toLowerCase();
      
//       // Define mapping for summary fields to source groups
//       const summaryMapping = {
//         'scope-1': 'A1',      // Sum all A1 fields for Scope-1
//         'scope-2': 'B1',      // Sum all B1 fields for Scope-2  
//         'scope-3': ['C1', 'C2']  // Sum all C1 and C2 fields for Scope-3
//       };

//       const fieldNameLower = fieldName.toLowerCase();
//       let sourceGroupPatterns = null;

//       // Find matching pattern
//       for (const [key, patterns] of Object.entries(summaryMapping)) {
//         if (fieldNameLower.includes(key)) {
//           sourceGroupPatterns = Array.isArray(patterns) ? patterns : [patterns];
//           break;
//         }
//       }

//       if (!sourceGroupPatterns) {
//         return 0; // No aggregation needed
//       }

//       // Get all fields from source groups
//       let aggregateSum = 0;
//       sourceGroupPatterns.forEach(pattern => {
//         const sourceFields = getFieldsByGroupPattern(pattern);
        
//         // Sum data from all source fields in this pattern
//         sourceFields.forEach(sourceField => {
//           const fieldSum = approvedData
//             .filter(item => {
//               if (String(item.fieldId) !== String(sourceField.fieldId)) return false;
//               if (!isRecordFromSelectedYear(item, expectedYear)) return false;
//               const recordMonth = getRecordMonth(item);
//               return recordMonth === normalizedMonth;
//             })
//             .reduce((acc, item) => acc + (Number(item.prevValue) || 0), 0);
          
//           aggregateSum += fieldSum;
//         });
//       });

//       return aggregateSum;
//     };

//     // Build Excel data with Total column and group summary row
//     const excelData = [];
//     let idCounter = 1;
//     for (const [groupKey, fields] of Object.entries(grouped)) {
//       const groupLabel = STATIC_GROUPS?.aqi?.[groupKey] || groupKey;
//       // Main Group Heading
//       excelData.push({}, {
//         "Sr. No.": idCounter++,
//         "KPI Name": groupLabel,
//         "UOM": "",
//         ...Object.fromEntries(months.map(month => [`${month} ${selectedYear}`, ""])),
//         "Total": ""
//       });
//       const subGroups = groupByConsecutiveGroups(fields.sort((a, b) => Number(a.fieldId) - Number(b.fieldId)));
//       for (const subGroup of subGroups) {
//         const subGroupKey = subGroup[0]?.group;
//         const subLabel = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"].includes(subGroupKey)
//           ? ""
//           : STATIC_GROUPS?.aqi?.[subGroupKey] || subGroupKey;
//         if (subLabel) {
//           excelData.push({
//             "Sr. No.": "",
//             "KPI Name": subLabel,
//             "UOM": "",
//             ...Object.fromEntries(months.map(month => [`${month} ${selectedYear}`, ""])),
//             "Total": ""
//           });
//         }
//         // For group summary row (per month and total)
//         const groupFieldRows = [];
//         subGroup.forEach(field => {
//           const row = {
//             "Sr. No.": "",
//             "KPI Name": `a. ${field.fieldName || "-"}`,
//             "UOM": "",
//           };
//           let fieldTotal = 0;
//           months.forEach(month => {
//             const expectedYear = String(selectedYear);
//             const normalizedMonth = month.toLowerCase();
//             // Check if this is a summary field that needs aggregation
//             const fieldNameLower = (field.fieldName || "").toLowerCase();
//             const isSummaryField = fieldNameLower.includes('scope-1') || 
//                                    fieldNameLower.includes('scope-2');
//             let sum = 0;
//             if (isSummaryField) {
//               sum = getAggregateSum(field.fieldName, month, expectedYear);
//             } else {
//               sum = approvedData
//                 .filter(item => {
//                   if (String(item.fieldId) !== String(field.fieldId)) return false;
//                   if (!isRecordFromSelectedYear(item, expectedYear)) return false;
//                   const recordMonth = getRecordMonth(item);
//                   return recordMonth === normalizedMonth;
//                 })
//                 .reduce((acc, item) => acc + (Number(item.prevValue) || 0), 0);
//             }
//             row[`${month} ${expectedYear}`] = sum !== 0 ? sum : "";
//             fieldTotal += sum;
//             if (!row["UOM"]) {
//               const match = approvedData.find(item => {
//                 if (String(item.fieldId) !== String(field.fieldId)) return false;
//                 if (!isRecordFromSelectedYear(item, expectedYear)) return false;
//                 const recordMonth = getRecordMonth(item);
//                 return recordMonth === normalizedMonth;
//               });
//               if (match) row["UOM"] = getUnitDisplay(field, match);
//             }
//           });
//           row["Total"] = fieldTotal || "";
//           groupFieldRows.push(row);
//           excelData.push(row);
//         });
//         // Add group summary row (sum of all fields in group, per month and total)
//         if (groupFieldRows.length > 0) {
//           const summaryRow = {
//             "Sr. No.": "",
//             "KPI Name": "Group Total",
//             "UOM": "",
//           };
//           let groupTotal = 0;
//           months.forEach(month => {
//             const monthKey = `${month} ${selectedYear}`;
//             const monthSum = groupFieldRows.reduce((sum, row) => sum + (Number(row[monthKey]) || 0), 0);
//             summaryRow[monthKey] = monthSum || "";
//             groupTotal += monthSum;
//           });
//           summaryRow["Total"] = groupTotal || "";
//           excelData.push(summaryRow);
//         }
//       }
//     }
    
//     if (excelData.length === 0) {
//       showAlert("Nothing to export");
//       return;
//     }
    
//     const unitName = getCompanyUnitName?.() ?? "Unknown Unit";
//     const sheetData = [
//       ["Client Name", "Harman Finochem Limited"],
//       ["Location", unitName],
//       [],
//     ];
    
//     if (excelData.length > 0) {
//       const headers = Object.keys(excelData.find(row => Object.keys(row).length > 0) || {});
//       sheetData.push(headers);
//       excelData.forEach(obj => {
//         const row = headers.map(h => obj[h] ?? "");
//         sheetData.push(row);
//       });
//     }
    
//     const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Emission Monthly Summary");
//     XLSX.writeFile(workbook, `Emission_KPI_Summary_${selectedYear}.xlsx`);
//     showAlert("Emission Excel downloaded successfully!", true);
//   } catch (error) {
//     console.error("Emission Excel download error:", error);
//     showAlert("Failed to download Emission Excel");
//   }
// };


const handleDownloadEmissionExcel = async () => {
  try {
    const selectedYear = year;
    const emissionData = await fetchEmissionByYear({ year: selectedYear, companyUnit, showAlert });

    if (!emissionData || emissionData.length === 0) {
      showAlert("No emission data available for the selected year.");
      return;
    }

    const approvedForms = forms?.records?.filter(f => f.approvalStatus === "approved") || [];
    if (approvedForms.length === 0) {
      showAlert("No approved forms found");
      return;
    }
    const approvedFormIds = approvedForms.map(f => f.formId);
    const approvedData = emissionData.filter(item => approvedFormIds.includes(item.formId));
    if (approvedData.length === 0) {
      showAlert("No approved emission data available.");
      return;
    }

    const fullStructure = await fetchFieldsForExcel(catId, subCatId, kpiId);
    if (!fullStructure || fullStructure.length === 0) {
      showAlert("Full field structure not found");
      return;
    }

    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    // Group fields by groupKey
    const grouped = {};
    fullStructure.forEach(field => {
      const groupKey = field?.group?.[0] || "Unknown";
      if (!grouped[groupKey]) grouped[groupKey] = [];
      grouped[groupKey].push(field);
    });

    // Helper to get UOM
    const getUnitDisplay = (field, match) => (
      match?.unitmaster?.shortName ||
      match?.unitShortName ||
      match?.unitName ||
      match?.unit ||
      field?.unit ||
      units?.find(u =>
        u.id === field?.unitId ||
        u.id === field?.unit ||
        u.fullName === field?.unit ||
        u.shortName === field?.unit
      )?.shortName ||
      "N/A"
    );

    // Helper function to determine if a record belongs to the selected year
    const isRecordFromSelectedYear = (item, expectedYear) => {
      if (item.frequencyType?.toLowerCase() === 'daily') {
        if (item.frequencyDate) {
          const dateYear = new Date(item.frequencyDate).getFullYear();
          return String(dateYear) === String(expectedYear);
        }
        return false;
      } else {
        return String(item.frequencyYear) === String(expectedYear);
      }
    };

    // Helper function to get the month from a record
    const getRecordMonth = (item) => {
      if (item.frequencyType?.toLowerCase() === 'daily') {
        if (item.frequencyMonth && item.frequencyMonth.trim() !== '') {
          return item.frequencyMonth.toLowerCase();
        }
        if (item.frequencyDate) {
          const dateObj = new Date(item.frequencyDate);
          return dateObj.toLocaleString('default', { month: 'long' }).toLowerCase();
        }
        return null;
      } else {
        return item.frequencyMonth?.toLowerCase() || null;
      }
    };

    // Helper function to get fields by group pattern
    const getFieldsByGroupPattern = (pattern) => {
      return fullStructure.filter(field => {
        const group = field?.group;
        if (Array.isArray(group)) {
          return group.some(g => g.startsWith(pattern));
        }
        return group && group.startsWith(pattern);
      });
    };

    // Helper function to calculate aggregate sum for summary fields
    const getAggregateSum = (fieldName, month, expectedYear) => {
      const normalizedMonth = month.toLowerCase();
      
      // Define mapping for summary fields to source groups
      const summaryMapping = {
        'scope-1': 'A1',      // Sum all A1 fields for Scope-1
        'scope-2': 'B1',      // Sum all B1 fields for Scope-2  
        'scope-3': ['C1', 'C2']  // Sum all C1 and C2 fields for Scope-3
      };

      const fieldNameLower = fieldName.toLowerCase();
      let sourceGroupPatterns = null;

      // Find matching pattern
      for (const [key, patterns] of Object.entries(summaryMapping)) {
        if (fieldNameLower.includes(key)) {
          sourceGroupPatterns = Array.isArray(patterns) ? patterns : [patterns];
          break;
        }
      }

      if (!sourceGroupPatterns) {
        return 0; // No aggregation needed
      }

      // Get all fields from source groups
      let aggregateSum = 0;
      sourceGroupPatterns.forEach(pattern => {
        const sourceFields = getFieldsByGroupPattern(pattern);
        
        // Sum data from all source fields in this pattern
        sourceFields.forEach(sourceField => {
          const fieldSum = approvedData
            .filter(item => {
              if (String(item.fieldId) !== String(sourceField.fieldId)) return false;
              if (!isRecordFromSelectedYear(item, expectedYear)) return false;
              const recordMonth = getRecordMonth(item);
              return recordMonth === normalizedMonth;
            })
            .reduce((acc, item) => acc + (Number(item.prevValue) || 0), 0);
          
          aggregateSum += fieldSum;
        });
      });

      return aggregateSum;
    };

    // Build Excel data with Total column and group summary row
    const excelData = [];
    let idCounter = 1;
    for (const [groupKey, fields] of Object.entries(grouped)) {
      const groupLabel = STATIC_GROUPS?.aqi?.[groupKey] || groupKey;
      // Main Group Heading
      excelData.push({}, {
        "Sr. No.": idCounter++,
        "KPI Name": groupLabel,
        "UOM": "",
        ...Object.fromEntries(months.map(month => [`${month} ${selectedYear}`, ""])),
        "Total": ""
      });
      
      const subGroups = groupByConsecutiveGroups(fields.sort((a, b) => Number(a.fieldId) - Number(b.fieldId)));
      
      for (const subGroup of subGroups) {
        const subGroupKey = subGroup[0]?.group;
        const subLabel = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"].includes(subGroupKey)
          ? ""
          : STATIC_GROUPS?.aqi?.[subGroupKey] || subGroupKey;
        
        if (subLabel) {
          excelData.push({
            "Sr. No.": "",
            "KPI Name": subLabel,
            "UOM": "",
            ...Object.fromEntries(months.map(month => [`${month} ${selectedYear}`, ""])),
            "Total": ""
          });
        }
        
        // For group summary row (per month and total)
        const groupFieldRows = [];
        const groupMonthTotals = {};
        let groupTotalSum = 0;
        
        // Initialize group monthly totals
        months.forEach(month => {
          groupMonthTotals[month] = 0;
        });
        
        subGroup.forEach(field => {
          const row = {
            "Sr. No.": "",
            "KPI Name": `a. ${field.fieldName || "-"}`,
            "UOM": "",
          };
          
          const expectedYear = String(selectedYear);
          
          // Check if this field has yearly data first
          const yearlyData = approvedData.find(item =>
            String(item.fieldId) === String(field.fieldId) &&
            item.frequencyType === "Yearly" &&
            String(item.frequencyYear) === expectedYear
          );
          
          let fieldTotal = 0;
          let hasYearlyData = false;
          
          if (yearlyData && yearlyData.prevValue && Number(yearlyData.prevValue) > 0) {
            // Handle yearly data
            hasYearlyData = true;
            const yearlyValue = Number(yearlyData.prevValue);
            fieldTotal = yearlyValue;
            
            // Approach 1: Show yearly value only in Total column, leave months empty
            months.forEach(month => {
              row[`${month} ${selectedYear}`] = "";
            });
            
            // Set unit from yearly data
            row["UOM"] = getUnitDisplay(field, yearlyData);
            
          } else {
            // Handle monthly/daily data (existing logic)
            months.forEach(month => {
              const normalizedMonth = month.toLowerCase();
              
              // Check if this is a summary field that needs aggregation
              const fieldNameLower = (field.fieldName || "").toLowerCase();
              const isSummaryField = fieldNameLower.includes('scope-1') || 
                                     fieldNameLower.includes('scope-2');
              let sum = 0;
              
              if (isSummaryField) {
                sum = getAggregateSum(field.fieldName, month, expectedYear);
              } else {
                sum = approvedData
                  .filter(item => {
                    if (String(item.fieldId) !== String(field.fieldId)) return false;
                    if (!isRecordFromSelectedYear(item, expectedYear)) return false;
                    const recordMonth = getRecordMonth(item);
                    return recordMonth === normalizedMonth;
                  })
                  .reduce((acc, item) => acc + (Number(item.prevValue) || 0), 0);
              }
              
              row[`${month} ${selectedYear}`] = sum !== 0 ? sum : "";
              fieldTotal += sum;
              
              // Add to group monthly totals only for monthly/daily data
              groupMonthTotals[month] += sum;
              
              if (!row["UOM"]) {
                const match = approvedData.find(item => {
                  if (String(item.fieldId) !== String(field.fieldId)) return false;
                  if (!isRecordFromSelectedYear(item, expectedYear)) return false;
                  const recordMonth = getRecordMonth(item);
                  return recordMonth === normalizedMonth;
                });
                if (match) row["UOM"] = getUnitDisplay(field, match);
              }
            });
          }
          
          row["Total"] = fieldTotal || "";
          groupTotalSum += fieldTotal;
          groupFieldRows.push(row);
          excelData.push(row);
        });
        
        // Add group summary row (sum of all fields in group, per month and total)
        if (groupFieldRows.length > 0) {
          const summaryRow = {
            "Sr. No.": "",
            "KPI Name": "Group Total",
            "UOM": "",
          };
          
          months.forEach(month => {
            const monthKey = `${month} ${selectedYear}`;
            summaryRow[monthKey] = groupMonthTotals[month] || "";
          });
          summaryRow["Total"] = groupTotalSum || "";
          excelData.push(summaryRow);
        }
      }
    }
    
    if (excelData.length === 0) {
      showAlert("Nothing to export");
      return;
    }
    
    const unitName = getCompanyUnitName?.() ?? "Unknown Unit";
    const sheetData = [
      ["Client Name", "Harman Finochem Limited"],
      ["Location", unitName],
      [],
    ];
    
    if (excelData.length > 0) {
      const headers = Object.keys(excelData.find(row => Object.keys(row).length > 0) || {});
      sheetData.push(headers);
      excelData.forEach(obj => {
        const row = headers.map(h => obj[h] ?? "");
        sheetData.push(row);
      });
    }
    
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Emission Monthly Summary");
    XLSX.writeFile(workbook, `Emission_KPI_Summary_${selectedYear}.xlsx`);
    showAlert("Emission Excel downloaded successfully!", true);
  } catch (error) {
    console.error("Emission Excel download error:", error);
    showAlert("Failed to download Emission Excel");
  }
};
      const columns = React.useMemo(
    () => [
      {
        Header: "Sr. No.",
        Cell: ({ row: { _index } }) => _index + 1,
      },
      {
        Header: "Frequency Type",
        Cell: ({
          row: {
            _original: { frequencyType },
          },
        }) => frequencyType || "-",
      },
      {
        Header: "Frequency Date",
        Cell: ({
          row: {
            _original: { frequencyDate },
          },
        }) => frequencyDate || "-",
      },
      {
        Header: "Frequency Month",
        Cell: ({
          row: {
            _original: { frequencyMonth },
          },
        }) => frequencyMonth || "-",
      },
      {
        Header: "Frequency Year",
        Cell: ({
          row: {
            _original: { frequencyYear },
          },
        }) => frequencyYear || "-",
      },
      {
        Header: "Updated By",
        width: 150,
        Cell: ({
          row: {
            _original: { updater, creater, updatedAt },
          },
        }) => {
          const updaterName = updater?.first_name
            ? `${updater.first_name} ${updater.last_name}`
            : creater?.first_name
            ? `${creater.first_name} ${creater.last_name}`
            : "-";
          const formattedDate = updatedAt
            ? new Date(updatedAt).toLocaleDateString("en-GB")
            : "";

          return (
            <div>
              <div>{updaterName}</div>
              {formattedDate && (
                <div style={{ fontSize: "0.8em", color: "gray" }}>
                  ({formattedDate})
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: "Status",
        Cell: ({
          row: {
            _original: { approvalStatus },
          },
        }) => (approvalStatus === "approved" ? "Approved" : "Pending" || "-"),
      },
      {
        Header: "Approved By",
        width: 150,
        Cell: ({
          row: {
            _original: { approver, approvedAt },
          },
        }) => {
          const approverName = approver?.first_name
            ? `${approver.first_name} ${approver.last_name}`
            : "-";
          const formattedDate = approvedAt
            ? new Date(approvedAt).toLocaleDateString("en-GB")
            : "";

          return (
            <div>
              <div>{approverName}</div>
              {formattedDate && (
                <div style={{ fontSize: "0.8em", color: "gray" }}>
                  ({formattedDate})
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: "View",
        Cell: ({
          row: {
            _original: { formId, approvalStatus },
          },
        }) => {
          return (
            <span
              onClick={() => {
                navigate(isLoggedIn ? "/company/data" : "/admin/data", {
                  state: { formId, page: "aqi", store: "wasteStore", approvalStatus: approvalStatus },
                });
              }}
              className="btn btn-primary btn-sm btn-action waves-effect waves-light"
            >
              View
            </span>
          );
        },
      },
      {
        Header: "Log",
        Cell: ({
          row: {
            _original: { formId },
          },
        }) => (
          <i
            type="button"
            onClick={() => handleModalLogShow(formId)}
            className="mdi mdi-dots-vertical"
          ></i>
        ),
      },
      // {
      //   Header: "Actions",
      //   width: 270,
      //   Cell: ({
      //     row: {
      //       _original: { formId, approvalStatus },
      //     },
      //   }) => (
      //     <div style={{ display: "flex", gap: "10px" }}>
      //       {approvalStatus === ApprovalEnums.Approved ? (
      //         <span>-</span>
      //       ) : (
      //         <>
      //           {user.role === USER_ROLE.Company || kpi.isApproved ? (
      //             <>
      //               <button
      //                 className="btn btn-success btn-sm"
      //                 onClick={() => handleModalOpen("approve", formId)}
      //               >
      //                 Approve
      //               </button>
      //               <button
      //                 className="btn btn-primary btn-sm btn-action waves-effect waves-light"
      //                 onClick={() =>
      //                   navigate("/company/approve/environment", {
      //                     state: {
      //                       formId,
      //                       groupConstant: "aqi",
      //                       type: "emission",
      //                       kpiName,
      //                     },
      //                   })
      //                 }
      //               >
      //                 Edit
      //               </button>
      //               <button
      //                 className="btn btn-danger btn-sm"
      //                 onClick={() => handleModalOpen("delete", formId)}
      //               >
      //                 Delete
      //               </button>
      //             </>
      //           ) : (
      //             <>
      //               {kpi && (
      //                 <>
      //                   {kpi.isEdited && (
      //                     <button
      //                       className="btn btn-primary btn-sm btn-action waves-effect waves-light"
      //                       onClick={() =>
      //                         navigate("/company/approve/environment", {
      //                           state: {
      //                             formId,
      //                             groupConstant: "aqi",
      //                             type: "emission",
      //                             kpiName,
      //                             year,
      //                           },
      //                         })
      //                       }
      //                     >
      //                       Edit
      //                     </button>
      //                   )}
      //                 </>
      //               )}
      //             </>
      //           )}
      //         </>
      //       )}
      //     </div>
      //   ),
      // },
      {
        Header: "Actions",
        width: 270,
        Cell: ({
          row: {
            _original: { formId, approvalStatus },
          },
        }) => (
          <div style={{ display: "flex", gap: "10px" }}>
            {approvalStatus === ApprovalEnums.Approved ? (
              <>
                {(user.role === USER_ROLE.Company|| user.department === "Admin") ? (
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleModalOpen("delete", formId)}
                  >
                    Delete
                  </button>
                ) : (
                  <span>-</span>
                )}
              </>
            ) : (
              <>
                {user.role === USER_ROLE.Company|| user.department === "Admin" || kpi.isApproved ? (
                  <>
                    <button
                      className="btn btn-success btn-sm"
                      onClick={() => handleModalOpen("approve", formId)}
                    >
                      Approve
                    </button>
                    <button
                      className="btn btn-primary btn-sm btn-action waves-effect waves-light"
                      onClick={() =>
                        navigate("/company/approve/environment", {
                          state: {
                            formId,
                            groupConstant: "aqi",
                            type: "emission",
                            kpiName,
                          },
                        })
                      }
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleModalOpen("delete", formId)}
                    >
                      Delete
                    </button>
                  </>
                ) : (
                  <>
                    {kpi?.isEdited && (
                      <button
                        className="btn btn-primary btn-sm btn-action waves-effect waves-light"
                        onClick={() =>
                          navigate("/company/approve/environment", {
                            state: {
                              formId,
                              groupConstant: "aqi",
                              type: "emission",
                              kpiName,
                              year,
                            },
                          })
                        }
                      >
                        Edit
                      </button>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        ),
      }
      
    ],
    [navigate, isLoggedIn, user.role, kpi, kpiName]
  );

  useEffect(
    () => () => {
      reset();
    },
    [reset]
  );

  // useEffect(() => {
  //   fetchForms({ type: "emission", page, pageSize: 10, filter: { year } });
  // }, [fetchForms, page, year]);

   const getFinancialYearFilter = (year, companyUnit) => ({
      frequencyYear: year,
      frequencyMonth: ['4','5','6','7','8','9','10','11','12','1','2','3'],
      companyUnit
    });
    
    useEffect(() => {
      fetchForms({
        type: "emission",
        page,
        pageSize: 12,
        filter: {year, companyUnit},
      });
    }, [fetchForms, page, year, companyUnit]);

  const handleView = (formId) => {
    navigate(isLoggedIn ? "/company/data" : "/admin/data", {
      state: { formId, page: "aqi", store: "wasteStore" },
    });
  };

  const handleEdit = (formId) =>
    navigate("/company/approve/environment", {
      state: {
        formId,
        groupConstant: "aqi",
        type: "emission",
        kpiName,
      },
    });


    const monthOrderMap = {
      April: 3, May: 4, June: 5, July: 6, August: 7, September: 8,
      October: 9, November: 10, December: 11, January: 0, February: 1, March: 2,
    };
    
        const sortedRecords = [...(forms?.records || [])].sort((a, b) => {
          const monthA = monthOrderMap[a.frequencyMonth] ?? 99;
          const monthB = monthOrderMap[b.frequencyMonth] ?? 99;
        
          const yearA = Number(a.frequencyYear);
          const yearB = Number(b.frequencyYear);
        
          // First sort by year (if needed), then month order
          if (yearA !== yearB) {
            return yearA - yearB;
          }
        
          return monthA - monthB;
        });

  return (
    <div className="water-list">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 font-size-18">Emission</h4>
              <div className="page-title-right">
                {isLoggedIn && (
                  <div
                    style={{
                      display: "flex",
                      marginLeft: "auto",
                      width: "fit-content",
                    }}
                  >
                    <div className="text-sm-end d-flex gap-1 flex-wrap">
                      <Performance label="Aqi" />
                      {/* <Financials
                        groups={["A", "B", "C"].map((group) => ({
                          group,
                          label: FINANCIALS_LABELS.energy[group],
                        }))}
                        key="aqi-financials"
                        guidance={PERMISSBLE_LIMIT_GUIDANCE}
                      /> */}
                      <Link to={`/${path}/aqi/add`}>
                        <button
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#newCustomerModal"
                          className="btn btn-secondary waves-effect waves-light addCustomers-modal"
                        >
                          <i className="mdi mdi-plus me-1"></i>Add Emission
                        </button>
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* End Page Title */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
          }}
        >
          {Object.entries(STATIC_GROUPS.aqi)
            .filter((e) => e[0].length === 1)
            .map(([group, title]) => (
              <div
                style={{
                  flex: "1 1 calc(50% - 20px)",
                  boxSizing: "border-box",
                }}
                key={group}
              >
                <DashboardHistogram
                  title={title}
                  group={group}
                  reportType="aqi"
                />
              </div>
            ))}
        </div>

        <div className="row mt-4">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                {/* <div className="row mb-2 align-items-center">
                  <div className="col-xl-3">
                    <label className="form-label">
                      Filter data on Annual basis
                    </label>
                    <select
                      className="form-select"
                      value={year || new Date().getFullYear()}
                      onChange={(event) => setYear(Number(event.target.value))}
                    >
                      {Array.from({ length: 5 })
                        .map((_, i) => new Date().getFullYear() - i)
                        .map((v) => (
                          <option key={v} value={v}>{`FY ${v}-${
                            v + 1
                          }`}</option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-6 col-xl-4 d-flex align-items-end">
                    <button
                      type="button"
                      className="btn btn-success ms-auto"
                      onClick={handleDownloadEmissionExcel}
                    >
                      <i className="mdi mdi-download me-1"></i> Download Excel
                    </button>
                  </div>

                </div> */}

 <div className="container">
  {/* First Row: Dropdown */}
  <div className="row mb-4">
    <div className="col-12 col-md-6 col-xl-4">
      <label className="form-label fw-semibold mb-2">
        Filter data on Annual basis
      </label>
      {/* <select
        className="form-select"
        value={year || new Date().getFullYear()}
        onChange={(event) => setYear(Number(event.target.value))}
      >
        {Array.from({ length: 5 })
          .map((_, i) => new Date().getFullYear() - i)
          .map((v) => (
            <option key={v} value={v}>{`FY ${v}-${v + 1}`}</option>
          ))}
      </select> */}
      <select
  className="form-select"
  value={year || new Date().getFullYear()}
  onChange={(event) => setYear(Number(event.target.value))}
>
  {Array.from({ length: 5 })
    .map((_, i) => new Date().getFullYear() - i)
    .map((v) => (
      <option key={v} value={v}>{`CY ${v}`}</option>
    ))}
</select>

    </div>
  </div>

  {/* Second Row: Button */}
  <div className="row mb-4">
    <div className="col-12 col-md-6 col-xl-4">
      <button
        type="button"
        className="btn btn-success"
        onClick={handleDownloadEmissionExcel}
      >
        <i className="mdi mdi-download me-1"></i> Download Excel
      </button>
    </div>
  </div>
</div> 
                <div className="table  dashboard-table">
                  {/* <DynamicTable
                    pageSize={forms?.records?.length || 0}
                    columns={columns}
                    data={forms?.records || []}
                  /> */}

                    <DynamicTable
                    pageSize={sortedRecords.length}
                    columns={columns}
                    data={sortedRecords}
                  />

                </div>
                <MobileTable
                  handleModalOpen={handleModalOpen}
                  handleView={handleView}
                  handleEdit={handleEdit}
                />
                <PaginationControls
                  page={page}
                  setPage={setPage}
                  totalPages={forms?.totalPages}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Approval Confirmation Modal */}
      <Modal
        show={showModal}
        onHide={handleModalClose}
        size={modalType === "log" ? "xl" : ""}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "approve"
              ? "Approve Form"
              : modalType === "delete"
              ? "Delete Form"
              : "Log Details"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflow: "hidden" }}>
          {modalType === "approve" && (
            <p>Are you sure you want to approve this form?</p>
          )}
          {modalType === "delete" && (
            <p>
              Are you sure you want to delete this form? Once deleted, all data
              associated with this form will be permanently removed and cannot
              be recovered.
            </p>
          )}
          {modalType === "log" && (
            <div style={{ overflowX: "auto" }}>
              <table className="table table-responsive scroll">
                <thead>
                  <tr key={12} className="waterTabletr">
                    <th key={0}>Username</th>
                    <th key={1}>Date</th>
                    <th key={2}>Action</th>
                    <th key={3}>Ip</th>
                    <th key={4}>Request</th>
                  </tr>
                </thead>
                <LogTableBody logRaw={logRaw} formId={selectedFormId} />
              </table>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Cancel
          </Button>
          {modalType === "approve" && (
            <Button variant="primary" onClick={handleConfirmAction}>
              Approve
            </Button>
          )}
          {modalType === "delete" && (
            <Button variant="primary" onClick={handleConfirmAction}>
              Delete
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default observer(AqiPage);
